import { useQuery } from '@tanstack/react-query'
import { useAppState } from './useAppState'
import { useSubmissionId } from './useSubmissionId'
import { instance } from '../constants/instance'
import { ApiReseponse } from '../types/ApiReseponse'
import { useError } from './useError'

export type SubmissionStatus = 'InProgress' | 'Failed' | 'Completed'

type GetSubmissionResponse = ApiReseponse<{
  submissionId: string
  status: SubmissionStatus
  overallQualityScore: number
  statusDescription?: string
  areaToImprove: string
}>

async function getSubmissionStatus(
  submissionId: string
): Promise<GetSubmissionResponse> {
  const { data } = await instance.get(`/api/widget/status/${submissionId}`)
  return data
}

export function usePollReportStatus() {
  const setStatus = useAppState((s) => s.setStatus)
  const setError = useError((s) => s.setError)
  const resetError = useError((s) => s.reset)
  const { submissionId, clearStorage } = useSubmissionId()
  return useQuery<GetSubmissionResponse>({
    queryKey: ['poll-report-status'],
    queryFn: async () => {
      resetError()
      const resposne = await getSubmissionStatus(submissionId!)
      if (resposne.data.status === 'Failed') {
        const message = resposne.data.statusDescription
        if (message) {
          setError(message)
        }
        setStatus('error')
        clearStorage()
      }

      if (resposne.data.status === 'Completed') {
        setStatus('complete')
        clearStorage()
      }

      return resposne
    },
    enabled: !!submissionId,
    refetchInterval: (q) =>
      q.state.data?.data.status !== 'Completed' ? 5000 : false,
  })
}
